/**
 * Product identification constants
 *
 * These values are sent to backend services for tracking and analytics.
 * They help distinguish between different chart implementations (Chart26 vs legacy ChartIQ)
 * and track version adoption across the user base.
 *
 * All values are automatically injected from package.json during build via Vite's define config.
 */

// Short product name for logging (used in backend LogAuth table)
// Injected from package.json "productName" field at build time
export const PRODUCT_NAME = __APP_PRODUCT_NAME__;

// Full display name (from package.json)
export const PRODUCT_DISPLAY_NAME = __APP_DISPLAY_NAME__;

// Product version (from package.json, injected at build time)
export const PRODUCT_VERSION = __APP_VERSION__;

// Product identifier (NPM package name from package.json)
export const PRODUCT_ID = __APP_NAME__;
